export enum EventType {
    Reservation = 0,
    Accommodation = 1,
    InHouse = 2
}